// 📁 src/components/ResultadosSimuladorComponent.jsx
import React from 'react';
import clsx from 'clsx';
import * as LucideIcons from 'lucide-react'; // Si usas Lucide para iconos

const ResultadosSimuladorComponent = ({ content, opciones, onOptionClick, isLastMessage }) => {
    let parsedContent;

    // Intentar parsear el contenido si es un string JSON
    if (typeof content === 'string') {
        try {
            parsedContent = JSON.parse(content);
        } catch (e) {
            console.error("Error al parsear el contenido JSON de ResultadosSimuladorComponent:", e);
            parsedContent = { titulo: "Error de Formato", texto: "No se pudieron cargar los resultados." };
        }
    } else {
        parsedContent = content; // Si ya es un objeto, úsalo directamente
    }

    // Asegurarse de que parsedContent no sea null o undefined después del parseo
    if (!parsedContent) {
        parsedContent = { titulo: "Error", texto: "Contenido de resultados no disponible." };
    }

    // Función auxiliar para obtener el icono de Lucide (si se usa)
    const Icon = ({ name, ...props }) => {
        const LucideIcon = LucideIcons[name];
        return LucideIcon ? <LucideIcon {...props} /> : null;
    };

    return (
        <div className={clsx(
            "flex flex-col items-start", // Los resultados siempre son de la IA
            "mb-6 overflow-x-hidden pb-4 first:mt-0"
        )}>
            <div className="w-full max-w-4xl mx-auto">
                <div className="w-[90%] sm:max-w-[85%] mx-auto flex items-start gap-2">
                    {/* Icono de la IA para resultados, similar a como lo manejas en MessageBubble */}
                    <div className="flex-shrink-0 w-6 h-6 md:w-9 md:h-9 rounded-full bg-gradient-to-br from-gray-100 to-gray-300 border shadow-inner items-center justify-center flex">
                        <Icon name="BarChart3" size={18} /> {/* O el icono que prefieras para resultados */}
                    </div>
                    <div className="bg-neutral-50 text-neutral-700 rounded-2xl px-4 py-3 shadow-md animate-fadeIn flex-1">
                        {parsedContent.titulo && (
                            <h2 className="text-xl font-bold text-blue-700 mb-2 flex items-center">
                                <Icon name="Trophy" className="w-6 h-6 mr-2 text-yellow-500" /> {/* Icono de victoria/trofeo */}
                                {parsedContent.titulo}
                            </h2>
                        )}
                        {parsedContent.texto && (
                            <p className="text-sm leading-relaxed mb-3">{parsedContent.texto}</p>
                        )}

                        {(typeof parsedContent.aciertos === 'number' || typeof parsedContent.porcentaje === 'number') && (
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-3 text-sm">
                                <p className="font-semibold text-blue-800 flex items-center">
                                    <LucideIcons.BarChart2 className="w-4 h-4 mr-2" />
                                    Tu Rendimiento:
                                </p>
                                {typeof parsedContent.aciertos === 'number' && (
                                    <p>Respuestas correctas: <span className="font-bold text-blue-900">{parsedContent.aciertos}</span></p>
                                )}
                                {typeof parsedContent.porcentaje === 'number' && (
                                    <p>Porcentaje de acierto: <span className="font-bold text-blue-900">{parsedContent.porcentaje.toFixed(2)}%</span></p>
                                )}
                            </div>
                        )}

                        {parsedContent.analisis && (
                            <div className="mt-3">
                                <h3 className="font-semibold text-gray-800 mb-1">Análisis:</h3>
                                <p className="text-sm leading-relaxed">{parsedContent.analisis}</p>
                            </div>
                        )}

                        {/* Renderizado de opciones (Volver al menú, etc.) */}
                        {isLastMessage && Array.isArray(opciones) && opciones.length > 0 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-4">
                                {opciones.map((op, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => onOptionClick(op.valor)}
                                        className="flex items-center justify-center px-4 py-2 bg-blue-100 text-blue-800 rounded-lg text-sm font-medium hover:bg-blue-200 transition-colors duration-200"
                                    >
                                        {op.icono && <Icon name={op.icono} className="w-4 h-4 mr-2" />}
                                        {op.etiqueta}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultadosSimuladorComponent;